import React, { FC } from 'react';
import { FormatQuote } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { getSelectedText } from '../../tiptapHelper';
import { useGuideCmsContext } from '../../../GuideCmsContext';

export const AddCitationLinkToolbarButton: FC = () => {
  const { openCitationLinkDialog } = useGuideCmsContext();
  const editor = useRichTextEditorContext();
  const handleOnClick = async () => {
    if (!editor) return;
    await openCitationLinkDialog(getSelectedText(editor));
  };
  if (!editor) return null;
  return (
    <MenuButton disabled={!editor?.isEditable} IconComponent={FormatQuote} tooltipLabel="Litteraturhenvisning" onClick={handleOnClick}></MenuButton>
  );
};
